import { Form } from "formik";
import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import * as yup from "yup";

import { adminRequests } from "@/api/(requests)/admin";
import { sharedRequests } from "@/api/(requests)/shared";

import Button from "../../../../UI/Button";
import { Card, FormField, Input } from "../../../../../component-library";
import CardHeading from "../../../../UI/Headings/CardHeading";
import { CustomForm } from "../../../../../component-library/CustomForm";
import Hr from "../../../../UI/Hr";
import SubmitControls from "../../../../Patient/Profile/SubmitControls";

const actionDescription =
  "This email is used to sign in to the platform and receive communications. Changing it " +
  "will trigger a verification email to the new address. The patient must verify their new email within 24 hours.";

const ChangePatientEmailCard = (props) => {
  const patientId = props.match.params.patientId;
  const [isEditing, setIsEditing] = useState(false);
  const [email, setEmail] = useState(props.patientDetails && props.patientDetails.email);

  const submitChangeEmail = async (formData, actions) => {
    const newEmail = formData.email;
    const changeEmailData = {
      new_email: newEmail,
      patient_id: patientId,
    };

    await adminRequests.change_patient_email({ data: changeEmailData });
    setEmail(newEmail);
    setIsEditing(false);
    const newPatientDetails = { ...props.patientDetails, email: newEmail };
    const activityResponse = await sharedRequests.fetch_patient_activity_feed({
      urlParams: { patientId },
    });
    const newTimelineData = { ...props.timelineData };

    newTimelineData["activities"] = activityResponse.results;
    props.updateState({ patientDetails: newPatientDetails, timelineData: newTimelineData });
  };

  const form = (formikProps) => {
    const { errors, handleBlur, handleChange, handleFocus, touched, values } = formikProps;

    return (
      <Form style={{ width: "100%" }}>
        <FormField
          className="apti-ChangePatientEmail"
          errorMessage={touched.email ? errors.email : ""}
          style={{ maxWidth: 350 }}
        >
          <Input
            error={touched.email && errors.email}
            name="email"
            onBlur={handleBlur}
            onChange={handleChange}
            onFocus={handleFocus}
            placeholder="Enter Email"
            value={values.email}
          />
        </FormField>
        <div className="mb-3 d-lg-none">
          <Hr />
        </div>
        <SubmitControls cancelHandler={() => setIsEditing(false)} />
      </Form>
    );
  };

  const validation = yup.object().shape({
    email: yup.string().email("Enter a valid email address").required("Email is required"),
  });

  return (
    <div className="AdminTab__ChangePatientEmailCard">
      <Card className="p-3 p-lg-4 mb-3 mb-lg-4">
        <div className="d-flex justify-content-between">
          <CardHeading className="fs-16 m-0 mb-3" text="Change Patient Email" />
          {!isEditing && (
            <Button
              className="ProviderProfile__ProfileDetailsCard-controls cursor mr-2 fs-14 mb-3 tw:font-bold"
              onClick={() => setIsEditing(!isEditing)}
            >
              Edit
            </Button>
          )}
        </div>
        <Hr />
        <div className="no-gutters row w-100">
          <div className="mt-4">
            <p className="admin-card-description">{actionDescription}</p>
            <p className="mb-1 font-weight-bold">Current Email</p>
            {!isEditing && (
              <div className="fs-14">
                <span>{email}</span>
              </div>
            )}
            {isEditing && (
              <CustomForm
                initialValues={{ email: email }}
                onSubmit={submitChangeEmail}
                render={form}
                validationSchema={validation}
              />
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default withRouter(ChangePatientEmailCard);
